<app-add-organization></app-add-organization>
<form *ngIf="false" [formGroup]="orgForm" (ngSubmit)="onSubmit()">
    <div class="bg-white rounded-lg py-3 mb-6 px-3">
      <div class="flex justify-between items-center mt-3 mb-6 px-6">
        <h1 class="font-semibold">Onboard Organization</h1>
      </div>
  
      <div class="form-row pt-4 px-3 gap-8">
        <div class="half-width">
          <mat-label>Org Type</mat-label>
  
          <mat-form-field appearance="outline" class="half-width">
            <mat-select formControlName="org_type" required>
              <mat-option value="cooperative">Cooperative (Co-op)</mat-option>
              <mat-option value="corporation">Corporation</mat-option>
              <mat-option value="franchise">Franchise</mat-option>
              <mat-option value="government_organization">Government Organization</mat-option>
              <mat-option value="joint_venture">Joint Venture</mat-option>
              <mat-option value="opc">One Person Company (OPC)</mat-option>
              <mat-option value="partnership">Partnership</mat-option>
              <mat-option value="private_limited">Private Limited Company (Pvt Ltd)</mat-option>
              <mat-option value="psu">Public Sector Undertaking (PSU)</mat-option>
              <mat-option value="public_limited">Public Limited Company (Ltd)</mat-option>
              <mat-option value="sole_proprietorship">Sole Proprietorship</mat-option>
              <mat-option value="trust">Trust</mat-option>
            </mat-select>
            <mat-error *ngIf="orgForm.get('org_type')?.hasError('required')">
              Org type is required
            </mat-error>
          </mat-form-field>
        </div>
  
        <div class="half-width">
          <mat-label>Organization Name</mat-label>
  
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="org_name" />
            <mat-error *ngIf="orgForm.get('org_name')?.hasError('required')">
              Organization name is required
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="false" class="half-width d-none">
          <mat-label>Registration Number</mat-label>
  
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="registration_number" placeholder="Registration Number" />
            <mat-error *ngIf="orgForm.get('registration_number')?.hasError('required')">
              Registration Number is required
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="false" class="half-width d-none">
          <mat-label>GST Number</mat-label>
  
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="gst_number" placeholder="GST Number" />
            <mat-error *ngIf="orgForm.get('gst_number')?.hasError('required')">
              GST Number is required
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="false" class="half-width d-none">
          <mat-label>PAN </mat-label>
  
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="pan_number" placeholder="PAN Number" />
            <mat-error *ngIf="orgForm.get('pan_number')?.hasError('required')">
              PAN is required
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="false" class="half-width d-none">
          <mat-label>Company Unique Code </mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="uniqueCode" placeholder="Unique Code" />
            <mat-error *ngIf="orgForm.get('uniqueCode')?.hasError('required')">
              Unique Code is required
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="true" class="half-width">
          <mat-label>Primary Contact</mat-label>
  
  
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="primary_contact_name" type="tel" />
            <mat-error *ngIf="orgForm.get('primary_contact_name')?.hasError('required')">
              primary_contact_name is required
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="true" class="half-width ">
          <mat-label>Primary Contact Name</mat-label>
  
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="primary_contact" type="text" />
            <mat-error *ngIf="orgForm.get('primary_contact')?.hasError('required')">
              Primary Contact Name is required
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="true" class="half-width">
          <mat-label>Primary Contact Number</mat-label>
  
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="primary_contact_phone" type="tel" />
            <mat-error *ngIf="orgForm.get('primary_contact_phone')?.hasError('required')">
              Primary Contact Number is required
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="false" class="half-width d-none">
          <mat-label>Primary Contact Email</mat-label>
  
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="primary_contact_email" type="text" />
            <mat-error *ngIf="orgForm.get('primary_contact_email')?.hasError('required')">
              Primary Contact Email is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>City</mat-label>
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="city" />
            <mat-error *ngIf="orgForm.get('city')?.hasError('required')">
              City is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>State</mat-label>
  
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="state" />
            <mat-error *ngIf="orgForm.get('state')?.hasError('required')">
              State is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Country</mat-label>
  
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="country" />
            <mat-error *ngIf="orgForm.get('country')?.hasError('required')">
              Country is required
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="false" class="half-width">
          <mat-label>Postal Code</mat-label>
  
          <mat-form-field appearance="outline" class="half-width">
            <input matInput formControlName="postal_code" />
            <mat-error *ngIf="orgForm.get('postal_code')?.hasError('required')">
              Postal code is required
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="false" class="half-width d-none">
          <mat-label>Onboarding Date</mat-label>
  
          <mat-form-field appearance="outline" class="half-width">
            <input matInput [matDatepicker]="picker" formControlName="onboarding_date" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="orgForm.get('onboarding_date')?.hasError('required')">
              Onboarding Date is required
            </mat-error>
          </mat-form-field>
        </div>
        <!-- Membership Dates -->
        <div *ngIf="false" class="half-width d-none">
          <mat-label>Membership Start Date</mat-label>
  
          <mat-form-field appearance="outline" class="half-width">
            <input matInput [matDatepicker]="startPicker" formControlName="membership_start_date">
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
            <mat-error *ngIf="orgForm.get('membership_start_date')?.hasError('required')">
              Start date is required
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="false" class="half-width d-none">
          <mat-label>Membership End Date</mat-label>
  
          <mat-form-field appearance="outline" class="half-width">
            <input matInput [matDatepicker]="endPicker" formControlName="membership_end_date">
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
            <mat-error *ngIf="orgForm.get('membership_end_date')?.hasError('required')">
              End date is required
            </mat-error>
          </mat-form-field>
        </div>
        <!-- Domain -->
        <div *ngIf="false" class="half-width d-none">
          <mat-label>Domain</mat-label>
  
          <mat-form-field appearance="outline" class="full-width">
            <mat-select formControlName="domain" required>
              <mat-option value="Commercial">Commercial</mat-option>
              <mat-option value="Education">Education</mat-option>
              <mat-option value="Electric">Electric</mat-option>
              <mat-option value="Gas">Gas</mat-option>
              <mat-option value="Residential">Residential</mat-option>
              <mat-option value="Road">Road</mat-option>
              <mat-option value="Water">Water</mat-option>
              <mat-option value="Telecom">Telecom</mat-option>
            </mat-select>
            <mat-error *ngIf="orgForm.get('domain')?.hasError('required')">
              Domain is required
            </mat-error>
          </mat-form-field>
        </div>
  
  
        <!-- Primary Contact (Nested Group) -->
        <div *ngIf="false" class="d-none">
          <h3>Primary Contact</h3>
          <div class="form-row pt-4 px-3 gap-8">
            <div class="half-width">
              <mat-label>Name</mat-label>
  
              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="primary_contact_name" required>
                <mat-error *ngIf="orgForm.get('primary_contact_name')?.hasError('required')">
                  Name is required
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>Email</mat-label>
  
              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="primary_contact_email" required>
                <mat-error *ngIf="orgForm.get('primary_contact_email')?.hasError('required')">
                  Email is required
                </mat-error>
                <mat-error *ngIf="orgForm.get('primary_contact_email')?.hasError('email')">
                  Invalid email
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
  
              <mat-label>Mobile</mat-label>
              <mat-form-field appearance="outline" class="half-width">
                <input matInput formControlName="primary_contact_phone" required>
                <mat-error *ngIf="orgForm.get('primary_contact_phone')?.hasError('required')">
                  Mobile is required
                </mat-error>
                <mat-error *ngIf="orgForm.get('primary_contact_phone')?.hasError('pattern')">
                  Must be a 10-digit number
                </mat-error>
              </mat-form-field>
            </div>
          </div>
  
        </div>
        <div *ngIf="false" formArrayName="keyContacts">
          <div *ngFor="let contact of keyContacts.controls; let i = index" [formGroupName]="i" class="contact-block">
            <mat-card class="mb-3">
              <mat-card-title>Contact {{ i + 1 }}</mat-card-title>
              <mat-card-content class="form-row pt-4 px-3 gap-8">
                <div class="half-width">
                  <mat-label>Name</mat-label>
  
                  <mat-form-field appearance="outline" class="half-width">
                    <input matInput formControlName="name" />
                    <mat-error *ngIf="contact.get('name')?.hasError('required')">Name is required</mat-error>
                  </mat-form-field>
                </div>
                <div class="half-width">
                  <mat-label>Email</mat-label>
  
                  <mat-form-field appearance="outline" class="half-width">
                    <input matInput formControlName="email" />
                    <mat-error *ngIf="contact.get('email')?.hasError('required')">Email is required</mat-error>
                    <mat-error *ngIf="contact.get('email')?.hasError('email')">Invalid email</mat-error>
                  </mat-form-field>
                </div>
                <div class="half-width">
                  <mat-label>Role</mat-label>
  
                  <mat-form-field appearance="outline" class="half-width">
                    <input matInput formControlName="role" />
                    <mat-error *ngIf="contact.get('role')?.hasError('required')">Role is required</mat-error>
                  </mat-form-field>
                </div>
                <div class="half-width">
                  <mat-label>Mobile</mat-label>
  
                  <mat-form-field appearance="outline" class="half-width">
                    <input matInput formControlName="mobile" />
                    <mat-error *ngIf="contact.get('mobile')?.hasError('required')">Mobile is required</mat-error>
                    <mat-error *ngIf="contact.get('mobile')?.hasError('pattern')">Must be 10 digits</mat-error>
                  </mat-form-field>
                </div>
  
                <div class="text-right">
                  <button mat-stroked-button color="warn" type="button" (click)="removeContact(i)"
                    *ngIf="keyContacts.length > 1">
                    Remove
                  </button>
                </div>
              </mat-card-content>
  
            </mat-card>
          </div>
          <button mat-raised-button color="primary" type="button" (click)="addKeyContact()"
            *ngIf="keyContacts.length <= 3">Add Contact</button>
  
        </div>
  
        <!-- <div formArrayName="keyContacts">
      <h3>Key Contacts</h3>
      <div *ngFor="let contact of keyContacts.controls; let i = index" [formGroupName]="i">
             <h4>Contact {{ i + 1 }}</h4>
  
       <div class="form-row pt-4 px-3 gap-8">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name">
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email">
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Role</mat-label>
          <input matInput formControlName="role">
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Mobile No</mat-label>
          <input matInput formControlName="mobile">
        </mat-form-field>
       </div>
  
   
      </div>
    </div> -->
  
        <mat-slide-toggle *ngIf="false" formControlName="status" color="primary">
          {{ orgForm.get("status")?.value ? "Enabled" : "Disabled" }}
        </mat-slide-toggle>
      </div>
      <div *ngIf="false" class="flex flex-col gap-2 md:col-span-2">
        <div class="bg-white border-2 rounded-xl border-[#0058e9]">
          <div class="p-5 flex items-center justify-center">
            <div *ngIf="!imageurl" class="w-full">
              <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM5 11.1L7 9.1L12.5 14.6L16 11.1L19 14.1V5H5V11.1ZM5 13.929V19H8.1L11.086 16.015L7 11.929L5 13.929ZM19 19H10.929L16 13.929L19 16.929V19ZM14 8.5C14 9.32843 14.6716 10 15.5 10C16.3284 10 17 9.32843 17 8.5C17 7.67157 16.3284 7 15.5 7C14.6716 7 14 7.67157 14 8.5Z"
                  fill="#525B69" />
              </svg>
            </div>
            <div class="h-30 w-40">
              <img *ngIf="imageurl" [src]="imageurl" alt="Profile Image" class="h-40 w-40" />
            </div>
          </div>
          <div class="bg-primary text-[10px] text-white py-3 px-4 rounded-b-lg py-1">
            <h1 class="text-center" style="font-size: 14px">Change</h1>
          </div>
        </div>
  
        <div class="flex gap-4" style="display: none">
          <div class="flex flex-col w-full justify-end">
            <button>
              <label for="fileInput" title="File should be Jpeg, PNG and less than 3 MB"
                class="bg-primary text-white px-3 py-2 rounded-lg flex items-center cursor-pointer justify-center gap-2">
                <span class="flex">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_1977_10834)">
                      <path d="M9 16H15V10H19L12 3L5 10H9V16ZM5 18H19V20H5V18Z" fill="#F5F5F5" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1977_10834">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                Upload
              </label>
            </button>
  
            <input type="file" id="fileInput" title="File should be Jpeg, PNG less than 3 MB"
              (change)="handleFileInput($event)" accept=".jpg,.jpeg,.png" style="display: none" />
            <span class="tooltip">File should be Jpeg, PNG less than 3 MB</span>
          </div>
  
          <div *ngIf="errorMessage1" class="file-error text-[#d60000] text-[14.241px]">
            {{ errorMessage1 }}
          </div>
        </div>
      </div>
      <div class="form-actions">
        <button mat-raised-button color="primary" type="submit">{{ organizationId ? 'Update' : 'Submit' }}</button>
      </div>
    </div>
  </form>